export default __webpack_public_path__ + "static/media/element_91.bdaa5afe.avif";